<template lang="pug">
  span
    span(v-if="!isEditing") {{ value }}
    span(v-else)
      v-select.editable-text(
        :value.sync="value"
        solo
        flat
        outline
        single-line
        :items="items"
        :rules="rules"
        @input="handleInput"
        @update:error="handleError"
      )
</template>

<script>
export default {
  name: 'EditableDropDown',
  props: {
    value: String,
    isEditing: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleError(value) {
      this.$emit('update:error', value);
    },
  },
}
</script>

<style lang="scss" scoped>
.editable-text {
  /deep/ .v-input__slot {
    min-height: auto;
  }

  /deep/ input {
    padding: 10px 0;
    margin: 0;
  }
}

</style>